import { toast } from 'sonner';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiPut, operationsClient } from '@/lib/api/client';
import { taxCodeEndpoints } from '@/lib/api/endpoints';
import { taxGroupKeys, taxRateKeys, taxZoneKeys } from '@/lib/queryKeys';
import type { TaxRate, UpdateTaxRateDto } from '@/types/taxRate';

interface UpdateTaxRateVariables {
  id: string;
  dto: UpdateTaxRateDto;
}

function toUpdateTaxCodeDto({ id: _id, isDefault: _isDefault, ...dto }: UpdateTaxRateDto) {
  return dto;
}

export const useUpdateTaxRate = createMutationHook<TaxRate, UpdateTaxRateVariables>({
  mutationFn: ({ id, dto }) =>
    apiPut<TaxRate, ReturnType<typeof toUpdateTaxCodeDto>>(
      operationsClient,
      taxCodeEndpoints.update(id),
      toUpdateTaxCodeDto(dto),
    ),
  onSuccess: (_data, _variables, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: taxRateKeys.all() });
    void queryClient.invalidateQueries({ queryKey: taxZoneKeys.all() });
    void queryClient.invalidateQueries({ queryKey: taxGroupKeys.all() });
    toast.success('Tax rate updated');
  },
});
